
































































import {Component, Vue,} from "vue-property-decorator";
import {deepCopy, formatDate} from "@/auxillary"
import {MdbsIdProvider} from "@/api/tsclient";
import {currentUserModule, patientConsentModule} from "@/store";
import PatientConsentEditDialog from "@/components/patientConsent/PatientConsentEditDialog.vue";
import PatientConsentDto = MdbsIdProvider.PatientConsentDto;
import ConsentState = MdbsIdProvider.ConsentState;

@Component({
  components: {
    PatientConsentEditDialog
  },
  filters: {
    formatDate(date: Date): string {
      return formatDate(date, "-");
    }
  }
})
export default class PatientConsentTable extends Vue {
  private _loading: boolean = false;

  headers: any = [
    {
      text: 'Patient',
      align: 'left',
      value: 'realPatient.lastName'
    },
    {
      text: 'Studie',
      align: 'left',
      value: 'studySystem.displayName'
    },
    {
      text: 'Institut',
      align: 'left',
      value: 'institute.displayName'
    },
    {
      text: 'Erteilungsdatum',
      align: 'left',
      value: 'grantDate'
    },
    {
      text: 'Aktionen',
      sortable: false,
      width: "120px",
      value: 'actions'
    },
  ];

  search: string = "";

  itemToDelete: MdbsIdProvider.PatientConsentDto | null = null;
  itemToEdit: MdbsIdProvider.PatientConsentDto | null = null;

  async mounted() {
    await patientConsentModule.loadAll();
  }

  get patientConsents() {
    return patientConsentModule.consents;
  }

  get loading() {
    return this._loading || patientConsentModule.loading;
  }

  get showEditDialog() {
    return this.itemToEdit != null;
  }

  set showEditDialog(value: boolean) {
    if (!value) {
      this.itemToEdit = null;
    }
  }

  get canEditPatientConsent() {
    return true; //TODO Permission mgmgt
  }

  get canCreatePatientConsent() {
    return true; //TODO Permission mgmgt
  }

  canGrantPatientConsent(patientConsent: PatientConsentDto) {
    return currentUserModule.hasRight("PatientConsentGrantCmd") && patientConsent.status != ConsentState.Active;
  }

  canRevokePatientConsent(patientConsent: PatientConsentDto) {
    return currentUserModule.hasRight("PatientConsentRevokeCmd") && patientConsent.status == ConsentState.Active;
  }

  newPatientConsent() {
    this.itemToEdit = new PatientConsentDto();
  }

  editPatientConsent(patientConsent: PatientConsentDto) {
    this.itemToEdit = deepCopy(patientConsent);
  }

  async grantPatientConsentAsync(patientConsent: PatientConsentDto) {
    await patientConsentModule.grantPatientConsentAsync(patientConsent.id ?? "");
  }

  async revokePatientConsentAsync(patientConsent: PatientConsentDto) {
    await patientConsentModule.revokePatientConsentAsync(patientConsent.id ?? "")
  }

  async savePatientConsent(patient: PatientConsentDto) {
    if (this.itemToEdit == null)
      return;
    let patientConsentToSave = patient;

    this.itemToEdit = null;
    if (!patientConsentToSave.id) {

      const dto = {
        realPatientId: patientConsentToSave.realPatientId,
        instituteId: patientConsentToSave.instituteId,
        studySystemId: patientConsentToSave.studySystemId,
        grantDate: patientConsentToSave.grantDate
      };

      console.log("create dto: " + JSON.stringify(dto))

      await patientConsentModule.createConsent(dto)
    } else {

      const dto = {
        id: patientConsentToSave.id,
        realPatientId: patientConsentToSave.realPatient?.id ?? "",
        instituteId: patientConsentToSave.institute?.id ?? "",
        studySystemId: patientConsentToSave.studySystem?.id ?? "",
        grantDate: patientConsentToSave.grantDate
      };

      console.log("update dto: " + JSON.stringify(dto))

      await patientConsentModule.updatePatientConsent(dto);
    }
  }
}
